import * as React from 'react';
import { Modal } from 'react-bootstrap';
import LiquidacionDetalleTabla from './LiquidacionDetalleTabla';
import DetalleVerBoton from './DetalleVerBoton';
import { postAgregarOrdenesALiquidacion, postResumenOrdenesSellerParaLiquidar } from '../../../../api/axios';
import { toast } from '../../../../utilities/appToast';
import { toastApiErrors } from '../../../../utilities/apiErrors';

const TABLE_HEAD = (
    <tr>
        <th scope="col">N° Orden</th>
        <th scope="col">Tipo</th>
        <th scope="col">Estado</th>
        <th scope="col">Fecha</th>
        <th scope="col">Importe</th>
        <th scope="col">Comisión Neta</th>
        <th scope="col">Comisión Total</th>
        <th scope="col">Importe Total</th>
        <th scope="col">Total Retenciones</th>
    </tr>
);

export default class OrdenesDeLiquidacionBorrador extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ordenes: props.ordenes ?? [],
            seleccionarTodo: false,
            showAgregarOrdenes: false,
            filtroOrdenes: {
                fechaDesde: '',
                fechaHasta: '',
            },
            showResultadosOrdenes: false,
            resultadosOrdenes: null,
            isLoadingResultadosOrdenes: false,
            activeResultadoTab: 'aptas',
            ordenesSeleccionadasPorTab: {
                aptas: {},
                noIncluidas: {},
                noCumplenEnvio: {},
            },
            isAddingOrdenes: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.ordenes !== this.props.ordenes) {
            this.setState({
                ordenes: this.props.ordenes ?? [],
            });
        }
    }

    handleChangeCheckbox = (id) => {
        this.setState((prevState) => {
            const ordenes = prevState.ordenes.map((orden) => {
                if (orden.idOrden === id) {
                    return {
                        ...orden,
                        checked: !orden.checked,
                    };
                }
                return orden;
            });
            return { ordenes };
        });
    };

    handleSelectAllCheckbox(seleccionarTodo) {
        this.setState((prevState) => {
            const ordenes = prevState.ordenes.map((orden) => ({
                ...orden,
                checked: seleccionarTodo,
            }));
            return { ordenes, seleccionarTodo };
        });
    }

    abrirFiltroOrdenes = () => {
        this.setState({ showAgregarOrdenes: true });
    };

    cerrarFiltroOrdenes = () => {
        this.setState({ showAgregarOrdenes: false });
    };

    handleFiltroChange = (event) => {
        const { name, value } = event.target;
        this.setState((prevState) => ({
            filtroOrdenes: {
                ...prevState.filtroOrdenes,
                [name]: value,
            },
        }));
    };

    handleBuscarOrdenes = (event) => {
        event.preventDefault();
        const { fechaDesde, fechaHasta } = this.state.filtroOrdenes;
        const idSeller = this.props.liquidacion?.idSeller ?? this.props.liquidacion?.IdSeller;

        const request = {
            fechaDesde: fechaDesde || null,
            fechaHasta: fechaHasta || null,
            idSeller: idSeller != null ? Number.parseInt(idSeller, 10) : null,
            idVentas: null,
        };

        this.setState({ isLoadingResultadosOrdenes: true });
        postResumenOrdenesSellerParaLiquidar(request)
            .then((resultados) => {
                this.setState({
                    showAgregarOrdenes: false,
                    showResultadosOrdenes: true,
                    resultadosOrdenes: resultados ?? {},
                    activeResultadoTab: 'aptas',
                    ordenesSeleccionadasPorTab: {
                        aptas: {},
                        noIncluidas: {},
                        noCumplenEnvio: {},
                    },
                });
            })
            .catch((error) => {
                toastApiErrors(error, toast, {
                    fallbackMessage: 'No se pudo consultar el resumen de órdenes',
                    hideItem1: true,
                });
            })
            .finally(() => {
                this.setState({ isLoadingResultadosOrdenes: false });
            });
    };

    cerrarResultadosOrdenes = () => {
        this.setState({ showResultadosOrdenes: false });
    };

    getResultadoValue = (item, camelCaseName, pascalCaseName) => item?.[camelCaseName] ?? item?.[pascalCaseName];

    cambiarResultadoTab = (activeResultadoTab) => {
        this.setState({ activeResultadoTab });
    };

    ordenNoDisponibleParaLiquidar = (item) => Number(this.getResultadoValue(item, 'idMotivo', 'IdMotivo')) === 3;

    cambiarSeleccionOrden = (tabKey, item) => {
        if (this.ordenNoDisponibleParaLiquidar(item)) return;

        const idOrden = this.getResultadoValue(item, 'idOrden', 'IdOrden');
        this.setState((prevState) => ({
            ordenesSeleccionadasPorTab: {
                ...prevState.ordenesSeleccionadasPorTab,
                [tabKey]: {
                    ...prevState.ordenesSeleccionadasPorTab[tabKey],
                    [idOrden]: !prevState.ordenesSeleccionadasPorTab[tabKey][idOrden],
                },
            },
        }));
    };

    renderCheckboxResultado = (tabKey, item) => {
        const idOrden = this.getResultadoValue(item, 'idOrden', 'IdOrden');
        const noDisponible = this.ordenNoDisponibleParaLiquidar(item);
        const seleccionada = Boolean(this.state.ordenesSeleccionadasPorTab[tabKey][idOrden]);

        return (
            <div className="liquidacion-resumen-ordenes__selection">
                <input
                    type="checkbox"
                    className="liquidacion-resumen-ordenes__checkbox"
                    aria-label={noDisponible ? `Orden ${idOrden} no disponible para liquidar` : `Seleccionar orden ${idOrden}`}
                    checked={noDisponible ? false : seleccionada}
                    disabled={noDisponible}
                    onChange={() => this.cambiarSeleccionOrden(tabKey, item)}
                />
                {noDisponible && <span className="liquidacion-resumen-ordenes__unavailable">No disponible</span>}
            </div>
        );
    };

    aceptarOrdenesSeleccionadas = () => {
        const idLiquidacion = this.props.liquidacion?.idLiquidacion ?? this.props.liquidacion?.IdLiquidacion;
        const idVentas = Object.values(this.state.ordenesSeleccionadasPorTab)
            .flatMap((selecciones) => Object.entries(selecciones))
            .filter(([, selected]) => selected)
            .map(([idOrden]) => Number.parseInt(idOrden, 10))
            .filter((idOrden) => Number.isInteger(idOrden) && idOrden > 0);

        if (!idLiquidacion || idVentas.length === 0) return;

        this.setState({ isAddingOrdenes: true });
        postAgregarOrdenesALiquidacion({
            idLiquidacion: Number.parseInt(idLiquidacion, 10),
            idVentas,
        })
            .then(() => {
                toast.success('Las órdenes fueron agregadas a la liquidación');
                this.props.onOrdenesAgregadas?.();
                this.setState({
                    showResultadosOrdenes: false,
                    ordenesSeleccionadasPorTab: {
                        aptas: {},
                        noIncluidas: {},
                        noCumplenEnvio: {},
                    },
                });
            })
            .catch((error) => {
                toastApiErrors(error, toast, {
                    fallbackMessage: 'No se pudieron agregar las órdenes a la liquidación',
                    hideItem1: true,
                });
            })
            .finally(() => {
                this.setState({ isAddingOrdenes: false });
            });
    };

    renderResultadoTabla = (title, items, columns, emptyMessage = 'Sin resultados') => (
        <section className="liquidacion-resumen-ordenes__section">
            <h6 className="liquidacion-resumen-ordenes__section-title">{title}</h6>
            {!items.length ? (
                <p className="liquidacion-resumen-ordenes__empty">{emptyMessage}</p>
            ) : (
                <div className="table-responsive">
                    <table className="table table-sm table-hover liquidacion-resumen-ordenes__table mb-0">
                        <thead>
                            <tr>{columns.map((column) => <th key={column.label}>{column.label}</th>)}</tr>
                        </thead>
                        <tbody>
                            {items.map((item, index) => (
                                <tr key={`${title}-${index}`}>
                                    {columns.map((column) => (
                                        <td key={column.label}>{column.render(item)}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </section>
    );

    renderResultadosOrdenes = () => {
        const resultados = this.state.resultadosOrdenes ?? {};
        const aptas = resultados.ordenesAptasParaLiquidar ?? resultados.OrdenesAptasParaLiquidar ?? [];
        const noIncluidas = resultados.ordenesNoIncluidas ?? resultados.OrdenesNoIncluidas ?? [];
        const noCumplenEnvio = resultados.ordenesNoCumplenReglasEnvio ?? resultados.OrdenesNoCumplenReglasEnvio ?? [];
        const estados = resultados.estadosOrdenes ?? resultados.EstadosOrdenes ?? [];
        const value = this.getResultadoValue;
        const tabs = [
            { key: 'aptas', label: 'Aptas para liquidar', items: aptas },
            { key: 'noIncluidas', label: 'No incluidas', items: noIncluidas },
            { key: 'noCumplenEnvio', label: 'Reglas de envío', items: noCumplenEnvio },
            { key: 'estados', label: 'Estados', items: estados },
        ];

        const contenidoTab = {
            aptas: this.renderResultadoTabla('Órdenes aptas para liquidar', aptas, [
                {
                    label: '',
                    render: (item) => this.renderCheckboxResultado('aptas', item),
                },
                { label: 'N° Orden', render: (item) => value(item, 'idOrden', 'IdOrden') },
                { label: 'Tipo', render: (item) => value(item, 'tipoPublicacion', 'TipoPublicacion') },
                { label: 'Fecha', render: (item) => value(item, 'fechaOrdenMostrar', 'FechaOrdenMostrar') },
                { label: 'Importe', render: (item) => `$${value(item, 'importeOrden', 'ImporteOrden') ?? 0}` },
                { label: 'Total', render: (item) => `$${value(item, 'totalOrden', 'TotalOrden') ?? 0}` },
                { label: 'Estado', render: (item) => value(item, 'descripcionEstado', 'DescripcionEstado') },
            ]),
            noIncluidas: this.renderResultadoTabla('Órdenes no incluidas', noIncluidas, [
                {
                    label: '',
                    render: (item) => this.renderCheckboxResultado('noIncluidas', item),
                },
                { label: 'N° Orden', render: (item) => value(item, 'idOrden', 'IdOrden') },
                { label: 'Seller', render: (item) => value(item, 'idSeller', 'IdSeller') },
                { label: 'Motivo', render: (item) => value(item, 'motivo', 'Motivo') },
            ]),
            noCumplenEnvio: this.renderResultadoTabla('Órdenes que no cumplen reglas de envío', noCumplenEnvio, [
                {
                    label: '',
                    render: (item) => this.renderCheckboxResultado('noCumplenEnvio', item),
                },
                { label: 'N° Orden', render: (item) => value(item, 'idOrden', 'IdOrden') },
                { label: 'Seller', render: (item) => value(item, 'idSeller', 'IdSeller') },
                { label: 'Motivo', render: (item) => value(item, 'motivo', 'Motivo') },
            ]),
            estados: this.renderResultadoTabla('Estados de órdenes', estados, [
                { label: 'N° Orden', render: (item) => value(item, 'idOrden', 'IdOrden') },
                { label: 'Seller', render: (item) => value(item, 'idSeller', 'IdSeller') },
                { label: 'Estado', render: (item) => value(item, 'estado', 'Estado') },
                { label: 'Motivo', render: (item) => value(item, 'motivo', 'Motivo') },
            ]),
        };
        const cantidadSeleccionadas = Object.values(this.state.ordenesSeleccionadasPorTab)
            .flatMap((selecciones) => Object.values(selecciones))
            .filter(Boolean)
            .length;

        return (
            <Modal
                show={this.state.showResultadosOrdenes}
                onHide={this.cerrarResultadosOrdenes}
                size="xl"
                centered
                aria-labelledby="resumen-ordenes-modal-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="resumen-ordenes-modal-title">Resumen de órdenes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="liquidacion-resumen-ordenes__totales">
                        <div><span>Total órdenes</span><strong>{value(resultados, 'totalOrdenes', 'TotalOrdenes') ?? 0}</strong></div>
                        <div><span>Aptas para liquidar</span><strong>{value(resultados, 'totalOrdenesAptasParaLiquidar', 'TotalOrdenesAptasParaLiquidar') ?? 0}</strong></div>
                        <div><span>Importe aptas</span><strong>${value(resultados, 'importeTotalOrdenesAptasParaLiquidar', 'ImporteTotalOrdenesAptasParaLiquidar') ?? 0}</strong></div>
                        <div><span>No incluidas</span><strong>{value(resultados, 'totalOrdenesNoIncluidas', 'TotalOrdenesNoIncluidas') ?? 0}</strong></div>
                    </div>
                    <div className="liquidacion-resumen-ordenes__tabs" role="tablist" aria-label="Resumen de órdenes">
                        {tabs.map((tab) => (
                            <button
                                key={tab.key}
                                type="button"
                                role="tab"
                                aria-selected={this.state.activeResultadoTab === tab.key}
                                className={`liquidacion-resumen-ordenes__tab ${this.state.activeResultadoTab === tab.key ? 'liquidacion-resumen-ordenes__tab--active' : ''}`}
                                onClick={() => this.cambiarResultadoTab(tab.key)}
                            >
                                {tab.label}
                                <span>{tab.items.length}</span>
                            </button>
                        ))}
                    </div>
                    <div className="liquidacion-resumen-ordenes__tab-content">
                        {contenidoTab[this.state.activeResultadoTab]}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-sm gestion-liquidaciones-btn-guardar"
                        disabled={cantidadSeleccionadas === 0 || this.state.isAddingOrdenes}
                        onClick={this.aceptarOrdenesSeleccionadas}
                    >
                        {this.state.isAddingOrdenes ? 'Agregando...' : 'Aceptar'}
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm gestion-liquidaciones-btn-cancelar"
                        onClick={this.cerrarResultadosOrdenes}
                    >
                        Cancelar
                    </button>
                </Modal.Footer>
            </Modal>
        );
    };

    render = () => {
        const liquidacion = this.props.liquidacion ?? {};
        const encabezado = liquidacion.encabezadoLiquidacion ?? {};
        const idTipoEstadoLiquidacion = Number(
            liquidacion.idTipoEstadoLiquidacion
            ?? liquidacion.IdTipoEstadoLiquidacion
            ?? encabezado.idTipoEstadoLiquidacion
            ?? encabezado.IdTipoEstadoLiquidacion
        );
        const descripcionEstado = String(
            liquidacion.descripcionEstado
            ?? liquidacion.DescripcionEstado
            ?? encabezado.descripcionEstado
            ?? encabezado.DescripcionEstado
            ?? ''
        ).trim().toLowerCase();
        const esEnPreparacion = idTipoEstadoLiquidacion === 2 || descripcionEstado === 'en preparación' || descripcionEstado === 'en preparacion';
        const puedeAgregarOrdenes = esEnPreparacion;

        return (
        <>
            <LiquidacionDetalleTabla
                title="Órdenes"
                data={this.state.ordenes}
                isLoading={this.props.isLoading}
                loadingMessage="Cargando ordenes del borrador..."
                emptyMessage="No hay órdenes para esta liquidación"
                tableHead={TABLE_HEAD}
                headerAction={puedeAgregarOrdenes ? (
                    <button
                        type="button"
                        className="liquidacion-detalle-tabla-card__header-action"
                        aria-label="Agregar más órdenes"
                        onClick={this.abrirFiltroOrdenes}
                    >
                        <span aria-hidden="true">+</span>
                        Agregar más órdenes
                    </button>
                ) : null}
                renderRow={(orden, i, globalIndex) => (
                    <tr key={orden.idOrden ?? globalIndex} className="hover-background-color">
                        <td><small>{orden.idOrden}</small></td>
                        <td><small>{orden.tipoPublicacionMostrar}</small></td>
                        <td><small>{orden.estado}</small></td>
                        <td><small>{orden.fechaMostrar}</small></td>
                        <td><small>${orden.totalOrden}</small></td>
                        <td><small>${orden.comisionNeto}</small></td>
                        <td><small>${orden.totalComision}</small></td>
                        <td><small>${orden.importe}</small></td>
                        <td>
                            <span className="d-inline-flex align-items-center flex-wrap gap-1">
                                <small>${orden.retencion}</small>
                                {orden.retencion > 0 && this.props.onVerDetalleRetenciones && (
                                    <DetalleVerBoton
                                        title="Ver detalle de retenciones"
                                        onClick={() => this.props.onVerDetalleRetenciones(orden.idOrden, 'orden')}
                                    />
                                )}
                            </span>
                        </td>
                    </tr>
                )}
            />

        <Modal
            show={this.state.showAgregarOrdenes}
            onHide={this.cerrarFiltroOrdenes}
            centered
            contentClassName="liquidacion-agregar-ordenes-modal"
            aria-labelledby="agregar-ordenes-modal-title"
        >
            <form onSubmit={this.handleBuscarOrdenes}>
                <Modal.Header closeButton>
                    <Modal.Title id="agregar-ordenes-modal-title">Agregar más órdenes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="liquidacion-agregar-ordenes-modal__intro">
                        Usá estos filtros para buscar las órdenes que querés sumar a la liquidación.
                    </p>
                    <div className="row g-3">
                        <div className="col-12 col-md-6">
                            <label htmlFor="ordenes-filtro-fecha-desde" className="form-label">Fecha desde</label>
                            <input
                                id="ordenes-filtro-fecha-desde"
                                type="date"
                                name="fechaDesde"
                                className="form-control"
                                value={this.state.filtroOrdenes.fechaDesde}
                                onChange={this.handleFiltroChange}
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <label htmlFor="ordenes-filtro-fecha-hasta" className="form-label">Fecha hasta</label>
                            <input
                                id="ordenes-filtro-fecha-hasta"
                                type="date"
                                name="fechaHasta"
                                className="form-control"
                                value={this.state.filtroOrdenes.fechaHasta}
                                onChange={this.handleFiltroChange}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-light" onClick={this.cerrarFiltroOrdenes}>
                        Cancelar
                    </button>
                    <button type="submit" className="btn background-rojo-megatone" disabled={this.state.isLoadingResultadosOrdenes}>
                        {this.state.isLoadingResultadosOrdenes ? 'Buscando...' : 'Buscar órdenes'}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
        {this.renderResultadosOrdenes()}
        </>
    );
    };
}
